import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import {
  Birthdate,
  ParticipantsCategory,
  ParticipantsWithBirthdateList
} from 'types/typescript'
import { GetParticipantsWithBirthdateList } from './types/getParticipantsWithBirthdateList.types'

export const getParticipantsWithBirthdateList: GetParticipantsWithBirthdateList = (participants) => (
  PARTICIPANTS_CATEGORIES.reduce<ParticipantsWithBirthdateList>((participantsWithBirthdateList, category: ParticipantsCategory) => {
    const { birthdates }: { birthdates: Birthdate[] } = participants[category]
    const birthdatesNumber = birthdates.length

    if (birthdatesNumber) {
      birthdates.forEach(birthdate => {
        birthdate && participantsWithBirthdateList.push(({
          birthdate: birthdate,
          origin: category
        }))
      })
    }

    return participantsWithBirthdateList
  }, [])
)
